module.exports = __webpack_public_path__ + "img/TH.14415155.svg";